module.exports = __webpack_public_path__ + "img/logo.025a1473.png";